import React from 'react';
import ContactMenu from './ContactMenu';
import '../styles/contact.css';
import ContactHandlers from './ContactHandlers';

const Contact = () => (
  <>
    <ContactMenu />
    <ContactHandlers />
  </>
);

export default Contact;
